export const APP_KEY = "hungry2021";
// export const API_URL = "http://localhost:5000/api/delivery";
// export const API_URL = "https://delivery.api.hungrytop.store/api/delivery";
export const API_URL = "https://api.hungrytop.in/api/delivery";  